var _style, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConciergeBlue = function SvgConciergeBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "concierge--blue_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".concierge--blue_svg__st0,.concierge--blue_svg__st1{fill:none;stroke:#0b1b34;stroke-width:2;stroke-miterlimit:10}.concierge--blue_svg__st1{fill:#0185ff;stroke:#fff}.concierge--blue_svg__st2{fill:#0b1b34}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 33.2v6.3",
    className: "concierge--blue_svg__st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4 53.4c.1-8.9-8.6-16.2-19.4-16.2s-19.4 7.2-19.4 16.2h38.8z",
    className: "concierge--blue_svg__st1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1 48.7c-1.3-2.7-3.8-5-6.8-6.4l6.8 6.4z",
    className: "concierge--blue_svg__st2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M54.1 48.7c-1.3-2.7-3.8-5-6.8-6.4",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4 34c0-1.6-1.6-2.9-3.5-2.9s-3.5 1.3-3.5 2.9h7z",
    className: "concierge--blue_svg__st2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3 59H17.6l3-5.5h38.8l2.9 5.5z",
    className: "concierge--blue_svg__st1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7 20.8v5.7M30.8 23.2l3.2 4.1M48.6 23.2l-3.2 4.1",
    className: "concierge--blue_svg__st0"
  })));
};
export default SvgConciergeBlue;